import {getEventId, getSlug} from '@wix/wix-events-commons-statics'
import {withTranslation} from '@wix/yoshi-flow-editor'
import {getEvent} from '../../../selectors/event'
import {getGiftCardPaymentDetails} from '../../../selectors/invoice'
import {getInvoice} from '../../../selectors/placed-order'
import {getReservationExpiration, getReservationId} from '../../../selectors/reservation'
import {DetailsPageAppProps} from '../../app/interfaces'
import {connect} from '../../runtime-context/context'
import {MobileCheckoutRuntimeProps} from './interfaces'
import {MobileCheckout as Presentation} from './mobile-checkout'

const mapRuntime = ({
  state,
  actions: {formPageLoaded, openTicketsDetailsModal, openTimeExpiredModal, closeNativeModal, scrollToElement},
}: DetailsPageAppProps): MobileCheckoutRuntimeProps => {
  const event = getEvent(state)
  return {
    eventId: getEventId(event),
    slug: getSlug(event),
    reservationId: getReservationId(state),
    reservationExpiration: getReservationExpiration(state),
    invoice: getInvoice(state),
    giftCardPaymentDetails: getGiftCardPaymentDetails(state),
    formPageLoaded,
    openTicketsDetailsModal,
    openTimeExpiredModal,
    closeNativeModal,
    scrollToElement,
  }
}

export const MobileCheckout = connect<{}, MobileCheckoutRuntimeProps>(mapRuntime)(withTranslation()(Presentation))
